import WidgetSuggestions from "./widget-suggestions";

export default WidgetSuggestions;